/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6a300c4a60656820eff56e28081cd978fbb8159f";
